// The receiver errors from api/src/parts/received-as.js. On any of these nothing
// was received, so the identity step stays open for a correction.
//
// A wrong PIN is a 403 on purpose: apiFetchAuthed reads every 401 as an expired
// session and would refresh the token and resend, spending two attempts and a
// token rotation on each typo.

const RECEIVER_ERROR_CODES = new Set([
  'receiver_invalid',
  'receiver_pin_invalid',
  'receiver_no_pin',
  'receiver_inactive',
  'receiver_pin_throttled',
]);

/** The message to show in the identity step, or null when the error is not one of ours. */
export function receiverErrorMessage(err: any): string | null {
  const body = err?.data?.error;
  if (!body || !RECEIVER_ERROR_CODES.has(body.code)) return null;
  return body.message || err?.message || 'That did not work. Check your name and PIN.';
}
